import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { IRating } from '@entities/review/model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewLikes',
  emits: ['selectSuggestion'],
  setup(__props, { emit }) {



const ratingInfo = ref<IRating[]>([
  { id: 1, label1: 'Прекрасная', label2: 'Атмосфера', picture: 'atmosfera', active: false },
  { id: 2, label1: 'Очень', label2: 'Чисто', picture: 'clean', active: false },
  { id: 3, label1: 'Красивый', label2: 'Интерьер', picture: 'interier', active: false },
  { id: 4, label1: 'Великолепное', label2: 'Обслуживание', picture: 'service', active: false },
  { id: 5, label1: 'Изысканные', label2: 'Блюда', picture: 'dish', active: false }
])

const selectSuggestion = (id: number) => {
  for (const i of ratingInfo.value) {
    if (i.id === id) {
      i.active = !i.active
      break
    }
  }

  const tags = ratingInfo.value.filter(i => i.active)

  emit('selectSuggestion', { type: 'ratingInfo', tags })
}

return { __sfc: true,emit, ratingInfo, selectSuggestion }
}

})